import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "details-banner" }
const _hoisted_2 = {
  key: 0,
  class: "text-center details-banner__loader"
}
const _hoisted_3 = { class: "details-banner__temperature" }
const _hoisted_4 = { class: "details-banner__temperature__city" }
const _hoisted_5 = { class: "details-banner__temperature__date" }
const _hoisted_6 = { class: "details-banner__temperature__tmp" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "details-banner__temperature__date"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "º", -1)
const _hoisted_10 = {
  key: 1,
  class: "details-banner__description"
}
const _hoisted_11 = ["src"]

import { ref } from 'vue'

interface CurrentWeather {
  city: string
  date: string
  description: string
  feelsLike: string
  icon: string
  temperature: string | number,
  lat: string | number,
  lon: string | number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsBanner',
  props: {
    currentWeather: null
  },
  setup(__props: any) {



const iconURL = ref('https://www.weatherbit.io/static/img/icons/')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.currentWeather.city)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Loading..."))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.currentWeather.city), 1),
      _createElementVNode("h6", _hoisted_5, _toDisplayString(__props.currentWeather.date), 1),
      _createElementVNode("h1", _hoisted_6, [
        _createTextVNode(_toDisplayString(__props.currentWeather.temperature), 1),
        (__props.currentWeather.temperature)
          ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "ºC"))
          : _createCommentVNode("", true)
      ]),
      (__props.currentWeather.temperature)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_8, [
            _createTextVNode("Feels like " + _toDisplayString(__props.currentWeather.temperature), 1),
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.currentWeather.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("img", {
            src: iconURL.value + __props.currentWeather.icon,
            alt: "",
            srcset: ""
          }, null, 8, _hoisted_11),
          _createElementVNode("h6", null, _toDisplayString(__props.currentWeather.description), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})